import React, { Component } from 'react';

import { pinyin } from 'pinyin-pro';


import Config from './../config/Config';
import WidgetAjax from './../widget/WidgetAjax';
import WidgetSelect from './../widget/WidgetSelect';
import WidgetTagPicker from './../widget/WidgetTagPicker';
import WidgetInputSelect from './../widget/WidgetInputSelect';

const basePath = Config.getBasePath();

class LocationPicker extends React.Component {

    constructor(props)
    {
        super(props)

        this.state = {
            provinceOptions:{
                title:"省份",
                type:"form"
            },
            cityOptions:{
                title:"城市",
                type:"form"
            },
            provinceData:[],
            province:undefined,
            cityMap:{},
            allCityData:[],
            cityData:[],
            city:undefined,
            countyMap:{},
            allCountyData:[],
            countyData:[],
            county:undefined,
            townMap:{},
            allTownData:[],
            townData:[],
            town:undefined,
            hotCityData:[
                {value:"100000", code:"100000", name:"全国", label:"全国" },
                {value:"110000", code:"110000", name:"北京市", label:"北京市", parent:"110000"},
                {value:"310000", code:"310000", name:"上海市", label:"上海市", parent:"310000"},
                {value:"330100", code:"330100", name:"杭州市", label:"杭州市", parent:"330000"},
                {value:"330700", code:"330700", name:"金华市", label:"金华市", parent:"330000"},
                {value:"441900", code:"441900", name:"东莞市", label:"东莞市", parent:"440000"}
            ],
            pinyinMap:{},
            cityPinyinData:{}

        }
    }

    componentDidMount()
    {
        this.loadArea();
    }

    loadArea = () => {

        const onLoadArea = (res) => {
            
            if( res.status===0)
            {
                this.buildProvince( res.results );

                this.buildPinyinCity( res.results );

                // this.buildCity( res.results );

                // this.buildCounty( res.results );

                // this.buildTown( res.results );
            }
        }
    
        WidgetAjax.ajax({ url: Config.getBasePath() + "/recruitment/area", params:{rank:2, parent_code:'100000'}, callback: onLoadArea })
    }

    handleConvert = ( value ) => {
        // 获取拼音首字母
        const initials = pinyin(value, {
          pattern: 'first',
          toneType: 'none'
        }).replace(/\s+/g, ''); // 移除空格
        
        return initials.toUpperCase().substring(0,1); // 转为大写
    };

    buildPinyinCity = ( data ) => {
        let { cityInitials=[], cityPinyinData={}, isMoreMap={} } = this.state;

        for( let item of data)
        {
            if( item.children )
            {
                for(let child of item.children)
                {
                    let initial = this.handleConvert(child.name);

                    if( !cityPinyinData[initial] )
                    {
                        cityPinyinData[initial]=[];
                    }

                    if( !isMoreMap[initial] )
                    {
                        isMoreMap[initial]=false;
                    }

                    cityPinyinData[initial].push({
                        ...child,
                        value:child.code,
                        label:child.name,
                    });
                }
            }
            else
            {
                let initial = this.handleConvert(item.name);

                if( !cityPinyinData[initial] )
                {
                    cityPinyinData[initial]=[];
                }

                if( !isMoreMap[initial] )
                {
                    isMoreMap[initial]=false;
                }

                cityPinyinData[initial].push({
                    ...item,
                    value:item.code,
                    label:item.name,
                });
            }
        }

        cityInitials = Object.keys(cityPinyinData);

        cityInitials.sort((a, b) => {return a.localeCompare(b) });

        this.setState({cityPinyinData:cityPinyinData, cityInitials:cityInitials}, () => {
            this.resizeMore();
        })
    }


    resizeMore = () => {

        const {cityInitials, isMoreMap={}} = this.state;

        for(let initial of cityInitials )
        {
            const element = document.getElementById('initial_tag_' + initial );

            if( element ) 
            {
                const height = element.scrollHeight;

                if( height>42 )
                {
                    isMoreMap[initial] = true;
                }
               
            }
        }

        this.setState({isMoreMap:isMoreMap});

        

    }

    buildProvince = ( data ) => {

        let provinceData = [];

        let { pinyinMap } = this.state;

        if( !pinyinMap["province"] )
        {
            pinyinMap["province"] = {}; 
        }
        
        for( let item of data )
        {
            provinceData.push({
                ...item,
                value:item.code,
                label:item.name,
            });

            let initial = this.handleConvert(item.name);

            if( !pinyinMap["province"][initial])
            {
                pinyinMap["province"][initial] = [];
            }

            pinyinMap["province"][initial].push({
                ...item,
                value:item.code,
                label:item.name,
            });

            if( item.children )
            {
                this.buildCity(item.children, item.code);
            }
        }

        let initials = Object.keys(pinyinMap["province"]);
        let pinyinData = pinyinMap["province"];

        this.setState({provinceData:provinceData, initials:initials, pinyinData:pinyinData})
    }

    buildCity = ( data, parentCode ) => {

        let {cityMap, allCityData, pinyinMap } = this.state;

        let cityData = [];

        if( !pinyinMap[parentCode] )
        {
            pinyinMap[parentCode] = {}
            pinyinMap[parentCode]["city"] = {}; 
        }
        else
        {
            if( !pinyinMap[parentCode]["city"] )
            {
                pinyinMap[parentCode]["city"] = {}; 
            }
        }

        for(let item of data )
        {
            cityData.push({
                ...item,
                value:item.code,
                label:item.name,
                parent: parentCode
            });

            let initial = this.handleConvert(item.name);

            if( !pinyinMap[parentCode]["city"][initial] )
            {
                pinyinMap[parentCode]["city"][initial] = [];
            }

            pinyinMap[parentCode]["city"][initial].push({
                ...item,
                value:item.code,
                label:item.name,
            });

            // if( item.children )
            // {
            //     this.buildCounty(item.children, item.code);
            // }
        }

        cityMap[parentCode] = cityData;

        allCityData.push(...cityData);

        this.setState({cityMap:cityMap, allCityData:allCityData})
    }

    buildCounty = ( data, parentCode ) => {
        
        let {countyMap={}, allCountyData, pinyinMap } = this.state;

        if( !pinyinMap["county"] )
        {
            pinyinMap["county"] = {}; 
        }

        let countyData = [];

        for(let item of data )
        {
            countyData.push({
                ...item,
                value:item.code,
                label:item.name,
                parent: parentCode
            });

            let initial = this.handleConvert(item.name);

            if( !pinyinMap["county"][initial] )
            {
                pinyinMap["county"][initial] = [];
            }

            pinyinMap["county"][initial].push({
                ...item,
                value:item.code,
                label:item.name,
            });

            if( item.children )
            {
                this.buildTown(item.children, item.code);
            }
        }

        countyMap[parentCode] = countyData;

        allCountyData.push(...countyData);

        this.setState({countyMap:countyMap, allCountyData:allCountyData})
    }

    buildTown = ( data, parentCode ) => {
        let {townMap={}, allTownData=[], pinyinMap} = this.state;

        let townData = [];

        if( !pinyinMap["town"] )
        {
            pinyinMap["town"] = {}; 
        }

        for(let item of data )
        {
            townData.push({
                ...item,
                value:item.code,
                label:item.name,
                parent: parentCode
            });


            let initial = this.handleConvert(item.name);

            if( !pinyinMap["town"][initial] )
            {
                pinyinMap["town"][initial] = [];
            }

            pinyinMap["town"][initial].push({
                ...item,
                value:item.code,
                label:item.name,
            });
        }

        townMap[parentCode] = townData;

        allTownData.push(...townData);

        this.setState({allTownData:allTownData, townMap:townMap})
    }

    provinceNotify = (value, item, labels) => {

        this.createCityData(value, item);
    }

    cityNotify = ( city, item ) => {

        let location = {...item};

        location["name"] = item.label;

        const { cityMap, countyMap, pinyinMap} = this.state;

        let cityData = [], countyData = [], initials=[], pinyinData={};

        if( cityMap[item.parent] )
        {
            cityData.push(... cityMap[item.parent]);
        }

        if( countyMap[city] )
        {
            countyData.push(... countyMap[city]);
        }

        if( pinyinMap[city] )
        {
            initials = Object.keys(pinyinMap[city]["city"]);
            pinyinData = {...pinyinMap[city]["city"]};
        }

        this.setState({location:location, province:item.parent, cityData:cityData, city:city, selectedTags:city, 
            countyData:countyData, initials:initials, pinyinData:pinyinData});

        if( this.props.notify )
        {
            this.props.notify(location);
        }
    }

    pinyinNotify = ( value, item ) => {

        const { province, city,  county, town} = this.state;

        if( !province )
        {   
            this.createCityData( value, item)
        }
        else if( !city )
        {
            this.createContryData(value, item);
        }
        else if( !county )
        {
            this.createTownData(value, item);
        }
        else
        {
            this.setState({town:value});

            if( this.props.notify )
            {
                this.props.notify({...item});
            }
        }
    }

    createTownData = ( value, item) => {

        const { townMap, pinyinMap } = this.state;

        let townData = [], initials=[], pinyinData={}, onOpen = true;

        if( townMap[value] )
        {
            townData.push(... townMap[value]);
        }

        if( pinyinMap[value] )
        {
            initials = Object.keys(pinyinMap[value]["town"]);
            pinyinData = {...pinyinMap[value]["town"]};
        }

        this.setState({county:value, townData:townData, initials:initials, pinyinData:pinyinData});

        if( townData.length===0  )
        {
            onOpen = false;
        }

        if( this.props.notify )
        {
            this.props.notify({...item}, onOpen);
        }
    }

    createContryData = ( value, item) => {

        const { countyMap, pinyinMap } = this.state;

        let countyData = [], initials=[], pinyinData={}, onOpen = true;

        if( countyMap[value] )
        {
            countyData.push(... countyMap[value]);
        }

        if( pinyinMap[value] )
        {
            initials = Object.keys(pinyinMap[value]["county"]);
            pinyinData = {...pinyinMap[value]["county"]};
        }

        this.setState({city:value, countyData:countyData, initials:initials, pinyinData:pinyinData});

        if( countyData.length===0  )
        {
            onOpen = false;
        }

        if( this.props.notify )
        {
            this.props.notify({...item}, onOpen);
        }
    }

    createCityData = ( value, item  ) => {

        const { cityMap, pinyinMap } = this.state;

        let cityData = [], initials=[], pinyinData={}, onOpen = true;

        item["name"] = item.label;

        if( cityMap[value] )
        {
            cityData.push(... cityMap[value]);
        }

        if( pinyinMap[value] )
        {
            initials = Object.keys(pinyinMap[value]["city"]);
            pinyinData = {...pinyinMap[value]["city"]};
        }

        this.setState({province:value, cityData:cityData, initials:initials, pinyinData:pinyinData});

        if( cityData.length===0  )
        {
            onOpen = false;
        }

        if( this.props.notify )
        {
            this.props.notify({...item}, onOpen);
        }
    }

    initialClick = ( initial ) => {

        const element = document.getElementById('initial_' + initial );

        element.scrollIntoView(false); // false表示底部对齐

        this.setState({activeInitial:initial})
    }

    clickMore = (type, initial) => {

        let { isExpandMap={} } = this.state;

        if( type==="collapse" )
        {
            isExpandMap[initial] = false
            this.setState({isExpandMap:isExpandMap})
        }
        else if( type==="expand" )
        {
            isExpandMap[initial] = true

            this.setState({isExpandMap:isExpandMap})
        }
    }

    render() 
    {
        const {provinceData, provinceOptions, province, city, cityData=[], cityOptions, allCityData, 
            hotCityData, initials=[], pinyinData={}, selectedTags, activeInitial, isExpandMap={}, isMoreMap={}, cityInitials=[],  cityPinyinData={}} = this.state;

            initials.sort((a, b) => {return a.localeCompare(b) });

        return (
            <div className="sf-location-body">
                <div className="sf-location-body-title">
                    <div className='sf-location-title'>按省份选择</div>
                    <div className='sf-location-item'><WidgetSelect options={provinceOptions} data={provinceData} defaultValue={province} onChange={this.provinceNotify} ></WidgetSelect></div>
                    {
                        province ? <div className='sf-location-item'><WidgetSelect options={cityOptions} data={cityData} defaultValue={city} onChange={this.cityNotify}></WidgetSelect></div> : <></>
                    }
                    <div className='sf-location-title'>直接搜索城市</div>
                    <div className='sf-location-item'><WidgetInputSelect data={allCityData} placeholder={"搜索城市名称"} notify={this.cityNotify}></WidgetInputSelect></div>
                </div>

                <div className="sf-location-body-title">
                    <div className='sf-location-title'>热门城市</div>
                    <div className='sf-location-tag'>
                        <WidgetTagPicker data={hotCityData} notify={this.cityNotify } selectedTags={selectedTags}></WidgetTagPicker>
                    </div>
                </div>

                <div className="sf-location-body-initial">
                    <div className='sf-location-anchor'>
                        <div className='sf-location-title'>按字母选择：</div>
                        <div className='sf-location-anchor-body'>
                        {
                            cityInitials.map((initial, key) => {
                                return <div key={initial + key} className='sf-location-anchor-item active' onClick={() => {this.initialClick(initial)}}>{initial}</div>
                            })
                        }
                        </div>
                    </div>
                    
    
                    <div className='sf-location-anchor-content'>
                    {
                        cityInitials.map((initial) => {

                            if( activeInitial===initial)
                            {
                                let className = "sf-location-anchor-content-item sf-location-anchor-content-item-active";
                                
                                if( isExpandMap[initial] )
                                {
                                    className += " sf-location-anchor-content-item-expand"
                                }

                                return  (
                                    <div className={className} id={"initial_" + initial}>
                                        <div className='sf-location-anchor-content-title'>{initial}</div>
                                        <div id={"initial_tag_" + initial} className='sf-location-anchor-content-tag'>
                                            <WidgetTagPicker data={cityPinyinData[initial]} notify={this.pinyinNotify }></WidgetTagPicker>
                                        </div>
                                        {
                                            isMoreMap[initial] ? 
                                            <>
                                            {
                                                isExpandMap[initial] ? <a className='sf-location-anchor-content-item-button' onClick={() => { this.clickMore("collapse", initial)}}>收起</a> : 
                                                <a className='sf-location-anchor-content-item-button' onClick={() => { this.clickMore("expand", initial)}}>更多</a>
                                            }
                                            </>:
                                            <></>
                                        }
                                        
                                    </div>
                                )
                            }
                            else
                            {
                                let className = "sf-location-anchor-content-item";
                                
                                if( isExpandMap[initial] )
                                {
                                    className += " sf-location-anchor-content-item-expand"
                                }

                                return  (
                                    <div className={className} id={"initial_" + initial}>
                                        <div className='sf-location-anchor-content-title'>{initial}</div>
                                        <div id={"initial_tag_" + initial} className='sf-location-anchor-content-tag'>
                                            <WidgetTagPicker data={cityPinyinData[initial]} notify={this.pinyinNotify }></WidgetTagPicker>
                                        </div>
                                        {
                                            isMoreMap[initial] ? 
                                            <>
                                            {
                                                isExpandMap[initial] ? <a  className='sf-location-anchor-content-item-button' onClick={() => { this.clickMore("collapse", initial)}}>收起</a> : 
                                                <a  className='sf-location-anchor-content-item-button' onClick={() => { this.clickMore("expand", initial)}}>更多</a>
                                            }
                                            </>:
                                            <></>
                                        }
                                    </div>
                                )
                            }
                        })
                    }  
                    </div>
                    
                </div>

            </div>
        )
    }

}

export default LocationPicker;